import { Button, ButtonProps } from 'antd';
import React from 'react';
import { genTestID } from '../utils/utils';

interface TaggedButtonOwnProps extends ButtonProps{
  tag:string
}

const TaggedButton = (props:TaggedButtonOwnProps) => {
  const { tag } = props;

  return (
    <Button {...props} data-testid={genTestID('button', tag)} />
  );
};

export default TaggedButton;
